import { login, logout, getInfo } from '@/api/login'
import { setToken, removeToken } from '@/utils/auth'

const user = {
    namespaced: true,

    state: {
        id: 0, // 用户编号
        name: '',
        nickname: '',
        avatar: '',
        classIds: [],
        courseIds: [],
        examPaperIds: [],
    },

    mutations: {
        SET_ID: (state, id) => {
            state.id = id
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_NICKNAME: (state, nickname) => {
            state.nickname = nickname
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_CLASS: (state, classIds) => {
            state.classIds = classIds
        },
        SET_COURSE: (state, courseIds) => {
            state.courseIds = courseIds
        },
    },

    actions: {
        // 登录
        Login({ commit }, userInfo) {
            const username = userInfo.username.trim()
            const password = userInfo.password
            return new Promise((resolve, reject) => {
                login(username, password).then(res => {
                    res = res.data;
                    // 设置 token
                    setToken(res)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                getInfo().then(res => {
                    // 没有 data 数据，赋予个默认值
                    if (!res) {
                        res = {
                            data: {
                                classIds: [],
                                courseIds: [],
                                examPaperIds: [],
                                user: {
                                    id: '',
                                    avatar: '',
                                    userName: '',
                                    nickname: ''
                                }
                            }
                        }
                    }

                    res = res.data; // 读取 data 数据
                    const user = res.user
                    const avatar = (user.avatar === "" || user.avatar == null) ? require("@/assets/image/profile.jpg") : user.avatar;
                    commit('SET_ID', user.id)
                    commit('SET_NAME', user.username)
                    commit('SET_NICKNAME', user.nickname)
                    commit('SET_AVATAR', avatar)
                    commit('SET_CLASS', res.classIds)
                    commit('SET_COURSE', res.courseIds)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 退出系统
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_CLASS', [])
                    commit('SET_COURSE', [])
                    removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}

export default user